import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const blockedwordService = {
    fetchBlockedWords,
    createBlockedWord,
    updateBlockedWord,
    deleteBlockedWord
};

function fetchBlockedWords() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(api.blockedword.fecthBlockedwords, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function createBlockedWord(blockedwordDetails) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return axiosInstance.post(api.blockedword.createBlockedword, blockedwordDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function updateBlockedWord(blockedwordDetails) {
    const requestOptions = {
        method: 'put',
        headers: authHeader()
    };

    return axiosInstance.put(api.blockedword.updateBlockedword, blockedwordDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function deleteBlockedWord(wordId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return axiosInstance.delete(`${api.blockedword.deleteBlockedword}/${wordId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}